import { Box } from '@mui/material';
import {
  Splide,
  SplideSlide,
  Splide as SplideInstance,
} from '@splidejs/react-splide';
import type { Splide as SplideClass } from '@splidejs/splide';
import { useRef, useEffect } from 'react';
import '@splidejs/react-splide/css';

interface CarouselProductImageProps {
  images: Array<string>;
}

export const CarouselProductImage = ({ images }: CarouselProductImageProps) => {
  const mainRef = useRef<SplideInstance>(null);
  const thumbsRef = useRef<SplideInstance>(null);

  useEffect(() => {
    if (mainRef.current && thumbsRef.current && thumbsRef.current.splide) {
      mainRef.current.sync(thumbsRef.current.splide as SplideClass);
    }
  }, []);

  return (
    <Box border="1px solid #ddd" borderRadius={3} p={3} width="100%" mx="auto">
      <Splide
        options={{
          arrows: false,
          autoplay: true,
          cover: true,
          height: 250,
          heightRatio: 0.6,
          interval: 4000,
          pagination: false,
          rewind: true,
          type: 'loop',
        }}
        ref={mainRef}
        aria-label="Main carousel"
      >
        {images.map((src, i) => (
          <SplideSlide key={i}>
            <Box
              component="img"
              src={src}
              alt={`thumbnail prod ${i + 1}`}
              sx={{
                height: 400,
                objectFit: 'cover',
                width: '100%',
              }}
            />
          </SplideSlide>
        ))}
      </Splide>

      <Box mt={3}>
        <Splide
          id="thumbnail-carousel-product-image"
          options={{
            arrows: true,
            cover: true,
            fixedHeight: 40,
            fixedWidth: 63,
            focus: 'center',
            gap: '1px',
            isNavigation: true,
            pagination: false,
            rewind: true,
            type: 'loop',
          }}
          ref={thumbsRef}
          aria-label="Thumbnails"
        >
          {images.map((src, i) => (
            <SplideSlide key={i}>
              <Box
                sx={{
                  '&:hover .hoverOverlay': {
                    opacity: 0.3,
                  },
                  height: '100%',
                  position: 'relative',
                  width: '100%',
                }}
              >
                <Box
                  className="hoverOverlay"
                  sx={{
                    bgcolor: 'white',
                    height: '100%',
                    left: 0,
                    opacity: 0,
                    position: 'absolute',
                    top: 0,
                    transition: 'opacity 0.3s ease-in-out',
                    width: '100%',
                    zIndex: 1,
                  }}
                />
                <Box
                  component="img"
                  src={src}
                  alt={`Thumbnail ${i + 1}`}
                  sx={{
                    height: '100%',
                    objectFit: 'cover',
                    width: '100%',
                  }}
                />
              </Box>
            </SplideSlide>
          ))}
        </Splide>
      </Box>
    </Box>
  );
};
